import React, { useEffect, useState } from "react";
import ProductList from "../components/ProductList";
import CategoryList from "../components/CategoryList";
import { Helmet } from 'react-helmet-async';
import { useNavigate,Link } from "react-router-dom";

const Homepage = () => {
  const [products, setProducts] = useState([]);
  const [activeAccordion, setActiveAccordion] = useState(null); // Track the active accordion
  const navigate = useNavigate();
  const heroImage =  "https://www.butterflyassets.online/products/WhatsApp%20Image%202023-02-06%20at%2010.27.59%20PM.jpeg";
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          "https://mycobro.com/api/products/all_stores/"
        );
        const data = await response.json();
        setProducts(data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  // Function to toggle the accordion
  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <div className="homepage">
      
<Helmet>
                <title>Pro Prime Mart:  Magic mushroom spores, whey protein,vending machines,researchchems and many more items from Top vendors</title>
                <meta name="description" content="pro prime mart has a  huge collection of the best Magic mushroom spores, vending machines,Whey Protein,Pure creatine,THC gummies,THC cartridges,researchchems and many other items."/>
            </Helmet>
      {/* Hero Section */}
      <section
        className="relative bg-cover bg-center h-[400px]"
        style={{
          backgroundImage: `url("${heroImage}")`,
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center text-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Welcome to Pro Prime Mart
            </h1>
            <p className="text-lg md:text-xl text-white">
            Shop the best vending machines,whey protein,THC cartridges,THC gummies,research chemicals , and many other items from over 50 stores and 700 products.
            </p>
            <button
              className="mt-6 bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700"
              onClick={() => navigate("/products")}
            >
              Products
            </button>
          </div>
        </div>
      </section>

      {/* Promotional Section */}
      <section className="py-16 bg-gray-100 text-center">
        <h2 className="text-3xl font-bold mb-6">What is our mission?</h2>
        <div className="flex flex-wrap justify-center space-x-6">
          <div className="w-full md:w-1/3 p-4 bg-white shadow rounded">
            <h3 className="text-xl font-semibold">Shop the best products from over 50 stores and more than 700 products</h3>
            <p className="text-gray-600">
              Shop the best Magic mushroom spores,whey protein,Vending machines,testosterone boosters,research chemicals and THC cartridges and many other items from over 50 stores and over 700 products.
              With over 50 stores and more than 700 products, we have selected the best Vending machines,whey protein,THC cartridges,THC gummies,magic mushroom spore syringes and other items you can choose what you want below in the our products section.
            </p>
          </div>
          <div className="w-full md:w-1/3 p-4 bg-white shadow rounded">
            <h3 className="text-xl font-semibold">Shop the best from the best</h3>
            <p className="text-gray-600">
              Discover new mushroom strains,vending machines,researchchems,THC gummies and supplements.
            </p>
          </div>
          <div className="w-full md:w-1/3 p-4 bg-white shadow rounded">
            <h3 className="text-xl font-semibold">quickly get to the product you are looking for by searching.just enter the name of the product you are looking for in the search bar.</h3>
            <p className="text-gray-600">

            </p>
          </div>
        </div>
      </section>
      <CategoryList/>
      <h4>Our top Products selected from our best Stores</h4>
      <ProductList products={products}/>
      {/* FAQ Section */}
      <div className="container mx-auto px-4 py-8">
        <h2 className="text-3xl font-bold text-center mb-6">New to Website?, Checkout the FAQ section below to get started.</h2>
        <div>
          {[
            {
              question: "What products are sold here",
              answer:
                "We have a huge collection of magic mushroom spores,whey protein,THC gummies,and many more from trusted stores.",
            },
            {
              question: "How can i be a vendor on your website?",
              answer:
                "Please visit the contact page and send a message from there.You will be directed what steps to take to start selling to thousands using our website.",
            },
            {
              question: "How long does delivery take?",
              answer:
                "Most stores have a delivery window of 2-3 days.",
            },
            {
              question: "Do you have a refund policy?",
              answer:
                "Yes,we have a 30-day money back refund policy.",
            },
          ].map((faq, index) => (
            <div
              key={index}
              className="border border-gray-300 rounded-md mb-4"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="flex justify-between w-full p-4 text-lg font-semibold focus:outline-none"
              >
                {faq.question}
                <span>{activeAccordion === index ? "-" : "+"}</span>
              </button>
              {activeAccordion === index && (
                <div className="p-4 text-gray-600">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default Homepage;
